import { render, staticRenderFns } from "./OrderAddProducts.vue?vue&type=template&id=bfbb70f6&scoped=true&"
import script from "./OrderAddProducts.vue?vue&type=script&lang=js&"
export * from "./OrderAddProducts.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddProducts.vue?vue&type=style&index=0&id=bfbb70f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbb70f6",
  null
  
)

export default component.exports